import React, { Fragment, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { slide as Menu } from 'react-burger-menu'
import perfilUser from '../../img/perfilUser.png';

{/* LOGOS EN BLANCO */ }
import LogoMagueySVG from '../../img/logoBlancoSVG2.svg';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import estilos from './MenuhamburguesaDivisionAgricola2.module.css'; { {/*Estilos para el componente*/ } }
import { BrowserRouter as Router, NavLink } from 'react-router-dom';
import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faCheckDouble, faClock, faCalendar,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faPenToSquare, faEdit, faPersonWalking, faRightFromBracket,
} from '@fortawesome/free-solid-svg-icons'
import BotonMenuHamburguesaDivisonAgricola from './BotonMenuHamburguesaDivisonAgricola';


library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faPenToSquare, faCheckDouble, faClock, faPersonWalking, faRightFromBracket,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faCalendar)


const MenuHamburguesaDivisionAgricola2 = (props) => {

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleCloseMenu = () => {
        setIsMenuOpen(false);
    };

    const handleStateChange = (state) => {
        setIsMenuOpen(state.isOpen);
    };

    var styles = {
        bmBurgerButton: {
            position: 'fixed',
            width: '36px',
            height: '30px',
            left: '36px',
            top: '20px'
        },
        bmBurgerBars: {
            background: 'white'
        },
        bmBurgerBarsHover: {
            background: '#81810e'
        },
        bmCrossButton: {
            height: '24px',
            width: '24px'
        },
        bmCross: {
            background: 'white'
        },
        bmMenuWrap: {
            position: 'fixed',
            height: '100%'
        },
        bmMenu: {
            background: '#81810e',
            padding: '2.5em 1.5em 0',
            fontSize: '1.15em'
        },
        bmMorphShape: {
            fill: '#373a47'
        },
        bmItemList: {
            color: 'white',
            padding: '0.8em'
        },
        bmItem: {
            display: 'inline-block'
        },
        bmOverlay: {
            background: 'rgba(0, 0, 0, 0.3)'
        }
    }



    const currentUser = useSelector(store => store.Usuario.data)
    const dataUser = useSelector(store => store.Usuario.user)

    const loginIn = localStorage.getItem('user')
    let idUsuario = 0
    if (currentUser) {
        idUsuario = currentUser.user[0].id
    }

    //OPCIONES
    const [registroPredio, setRegistroPredio] = React.useState([])

    React.useEffect(async () => {
        let datosMenu = []
        if (dataUser?.[0]?.idrol == 1) {
            datosMenu.push(
                { text: 'Registro Predio', ruta: '/PanelRegistroPredio' },
                { text: 'Descuento por Predio', ruta: '/Descuento_Predio' },
                { text: 'Reporte', ruta: '/PanelReporteExcel' },
                { text: 'Edición de Datos', ruta: '/DatosPredio' },
                { text: 'Generar Nuevas Guias', ruta: '/PanelConsultarGuia' },
                { text: 'Catálogo Maguey', ruta: '/PanelEditarMaguey' },
            )
        }
        if (dataUser?.[0]?.idrol == 9) {
            if (dataUser?.[0]?.permisosagricola?.registroPredio) datosMenu.push({ text: 'Registro Predio', ruta: '/PanelRegistroPredio' })
            if (dataUser?.[0]?.permisosagricola?.descuentoPredio) datosMenu.push({ text: 'Descuento por Predio', ruta: '/Descuento_Predio' })
            if (dataUser?.[0]?.permisosagricola?.reportes) datosMenu.push({ text: 'Reporte', ruta: '/PanelReporteExcel' })
            if (dataUser?.[0]?.permisosagricola?.edicionDatos) datosMenu.push({ text: 'Edición de Datos', ruta: '/DatosPredio' })
            if (dataUser?.[0]?.permisosagricola?.generarGuias) datosMenu.push({ text: 'Generar Nuevas Guias', ruta: '/PanelConsultarGuia' })
            if (dataUser?.[0]?.permisosagricola?.catalogoMaguey) datosMenu.push({ text: 'Catálogo Maguey', ruta: '/PanelEditarMaguey' })
        }
        setRegistroPredio(datosMenu)
    }, [dataUser])
    const constanciaMaguey = [
        { text: 'Constancia en Registro', ruta: '/Constancia' },
        { text: 'Registro Predios', ruta: '' },
        { text: 'Guía de extracción', ruta: '' },
        { text: 'Nuevas Guías', ruta: '' },
        { text: 'Datos del Predio', ruta: '' },
    ];


    const generadorEtiquetasOpciones = [

        { text: 'PanelGenerarNuevaGuia', ruta: '/PanelGenerarNuevaGuia' },
        { text: 'PanelReporteExcel', ruta: '/PanelReporteExcel' },

    ];
    const generarVisitaOpciones = [];

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const perfilusuario = () => {
        props.history.push('/PerfilUsuarioAgricola')
    }
    return (
        <Fragment>
            <div className={`${estilos.header}`}>
                <Fragment>
                    <header className='row'>
                        <div className='col-10'>
                            <div className='row'>
                                <div className='col-5 mt-3'>
                                    <button style={{ border: 'none', backgroundColor: '#81810e', color: 'white', fontFamily: 'Montserrat', float: 'left', marginLeft: '50%' }}
                                        onClick={() => { perfilusuario() }} className="botonZoom"> <img src={perfilUser} style={{ width: '25px', transform: 'scale(1.5)' }} /><br />Perfil</button>
                                </div>
                                <div className='col-5 mt-2' style={{ textAlign: 'center' }}>
                                    <span style={{ fontSize: '1vw' }} className='text-wrap textoEscondido text-center text-light'><strong>Panel Administrativo</strong><br /> <p>División Agricola - COMERCAM en Línea</p></span>
                                </div>
                            </div>
                        </div>
                        <div className='col-2 mt-3' style={{ textAlign: 'right', paddingRight: '4%' }}>
                            <Tooltip title="Salir de la aplicación" arrow>
                                <button className={`${estilos.lista} text-wrap text-center botonZoom`} style={{ border: 'none', padding: '0', color: 'white', fontFamily: 'Montserrat', boxShadow: 'none', textDecoration: 'none' }} onClick={props.cerrarSesionModal}> <FontAwesomeIcon style={{ transform: 'scale(1.5)' }} icon={faRightFromBracket} /><br />Salir</button>
                            </Tooltip>
                        </div>

                    </header>
                </Fragment>
            </div>

            <Menu isOpen={isMenuOpen} styles={styles} onStateChange={handleStateChange} >
                <List className={`${estilos.lista}`}>
                    {
                        props.idUsuario === 6 ?
                            (
                                <Fragment>
                                    {registroPredio?.length > 0 &&
                                        <BotonMenuHamburguesaDivisonAgricola setIsMenuOpen={handleCloseMenu} titulo="PREDIOS" objeto={registroPredio} ruta="#"></BotonMenuHamburguesaDivisonAgricola>
                                    }
                                    {dataUser?.[0]?.idrol == 1 &&
                                        <NavLink exact to="/PanelConstancia" className={`${estilos.section_dropdown}`} onClick={handleCloseMenu}>
                                            <FontAwesomeIcon icon={faCalendar} style={{ color: 'white', width: '10%' }} />
                                            <Button id="basic-button" aria-controls={'basic-menu'} aria-haspopup="true" aria-expanded={'true'} sx={{ color: 'white' }}  >
                                                <div className={`${estilos.nav_name} text-wrap`} style={{ color: 'white', textDecorationLine: 'underline' }}>CONSTANCIA</div>
                                            </Button>
                                        </NavLink>
                                    }
                                    {dataUser?.[0]?.permisosagricola?.constancias == true &&
                                        <NavLink exact to="/PanelConstancia" className={`${estilos.section_dropdown}`} onClick={handleCloseMenu}>
                                            <FontAwesomeIcon icon={faCalendar} style={{ color: 'white', width: '10%' }} />
                                            <Button id="basic-button" aria-controls={'basic-menu'} aria-haspopup="true" aria-expanded={'true'} sx={{ color: 'white' }}  >
                                                <div className={`${estilos.nav_name} text-wrap`} style={{ color: 'white', textDecorationLine: 'underline' }}>CONSTANCIA</div>
                                            </Button>
                                        </NavLink>
                                    }

                                    {dataUser?.[0]?.idrol == 1 &&
                                        <NavLink exact to="/PanelBuscarAsociado" className={`${estilos.section_dropdown}`} onClick={handleCloseMenu}>
                                            <FontAwesomeIcon icon={faCalendar} style={{ color: 'white', width: '10%' }} />
                                            <Button id="basic-button" aria-controls={'basic-menu'} aria-haspopup="true" aria-expanded={'true'} sx={{ color: 'white' }}  >
                                                <div className={`${estilos.nav_name} text-wrap`} style={{ color: 'white', textDecorationLine: 'underline' }}>INFORMACIÓN ASOCIADOS</div>
                                            </Button>
                                        </NavLink>
                                    }
                                    {dataUser?.[0]?.permisosagricola?.informacionAsociados == true &&
                                        <NavLink exact to="/PanelBuscarAsociado" className={`${estilos.section_dropdown}`} onClick={handleCloseMenu}>
                                            <FontAwesomeIcon icon={faCalendar} style={{ color: 'white', width: '10%' }} />
                                            <Button id="basic-button" aria-controls={'basic-menu'} aria-haspopup="true" aria-expanded={'true'} sx={{ color: 'white' }}  >
                                                <div className={`${estilos.nav_name} text-wrap`} style={{ color: 'white', textDecorationLine: 'underline' }}>INFORMACIÓN ASOCIADOS</div>
                                            </Button>
                                        </NavLink>
                                    }

                                    {dataUser?.[0]?.idrol == 1 &&
                                        <NavLink exact to="/PanelInformacionPredio" className={`${estilos.section_dropdown}`} onClick={handleCloseMenu}>
                                            <FontAwesomeIcon icon={faCalendar} style={{ color: 'white', width: '10%' }} />
                                            <Button id="basic-button" aria-controls={'basic-menu'} aria-haspopup="true" aria-expanded={'true'} sx={{ color: 'white' }} >
                                                <div className={`${estilos.nav_name} text-wrap`} style={{ color: 'white', textDecorationLine: 'underline' }}>INFORMACIÓN PREDIOS</div>
                                            </Button>
                                        </NavLink>
                                    }
                                    {dataUser?.[0]?.permisosagricola?.informacionPredios == true &&
                                        <NavLink exact to="/PanelInformacionPredio" className={`${estilos.section_dropdown}`} onClick={handleCloseMenu}>
                                            <FontAwesomeIcon icon={faCalendar} style={{ color: 'white', width: '10%' }} />
                                            <Button id="basic-button" aria-controls={'basic-menu'} aria-haspopup="true" aria-expanded={'true'} sx={{ color: 'white' }} >
                                                <div className={`${estilos.nav_name} text-wrap`} style={{ color: 'white', textDecorationLine: 'underline' }}>INFORMACIÓN PREDIOS</div>
                                            </Button>
                                        </NavLink>
                                    }
                                    {dataUser?.[0]?.idrol == 1 &&
                                        <NavLink exact to="/UsuariosAuxiliaresAgricola" className={`${estilos.section_dropdown}`} onClick={handleCloseMenu} >
                                            <FontAwesomeIcon icon={faCalendar} style={{ color: 'white', width: '10%', marginTop: '10px' }} />
                                            <Button id="basic-button" aria-controls={'basic-menu'} aria-haspopup="true" aria-expanded={'true'} sx={{ color: 'white' }} >
                                                <div className={`${estilos.nav_name} text-wrap`} style={{ color: 'white', textDecorationLine: 'underline' }}>USUARIOS DIVISIÓN AGRICOLA</div>
                                            </Button>
                                        </NavLink>
                                    }
                                </Fragment>
                            ) :

                            (
                                <></>
                            )
                    }
                </List>
            </Menu>

            <br /><br /><br /><br />

            {props.componenteCerrarSesionModal}
        </Fragment >
    );
};
export default withRouter(MenuHamburguesaDivisionAgricola2)
